export default __webpack_public_path__ + "static/media/map-user.331b43ea.svg";